import React from "react";
import {Tooltip} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

//参数与antd上Tooltip需要设置的参数一致
export default class Remarks extends React.Component {
    render(){
        return <Tooltip {...this.props}><QuestionCircleOutlined style={{fontSize:13.5,color:'gray'}} /></Tooltip>
    }
}